import script from "./KbsBase.vue?vue&type=script&setup=true&lang=js"
export * from "./KbsBase.vue?vue&type=script&setup=true&lang=js"

import "./KbsBase.vue?vue&type=style&index=0&id=4af49abe&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af49abe"]])

export default __exports__